import React, { PropTypes } from "react";
import HomePage from "../common/HomePage";
import ForgotPasswordForm from "./ForgotPasswordForm";
import simpleFetch from "../../../utils/simpleFetch";
import { intlShape, FormattedHTMLMessage } from "react-intl";
import { connect } from "react-redux";
import "./ForgotPasswordPage.css";

class ForgotPasswordPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      emailAddress: undefined,
    };
    this.formatMessage = this.context.intl.formatMessage;
  }

  handleForgotPassword(data) {
    this.setState({ emailAddress: data.emailAddress });
    return simpleFetch("post", "/v1/auth/initiate-reset-password", {
      body: data,
    });
  }

  getAuthError() {
    if (this.props.auth && this.props.auth.error) {
      return this.props.auth.error.data.error;
    }
  }

  render() {
    return (
      <HomePage>
        {this.getAuthError() ? (
          <p className="danger">
            <FormattedHTMLMessage id={`resetPassword.${this.getAuthError()}`} />
          </p>
        ) : null}
        {!this.state.emailAddress ? (
          <div className="instruction">
            <p>
              {this.formatMessage({ id: "resetPassword.resetInstructions" })}
            </p>
          </div>
        ) : (
          <div className="instruction text-success">
            <p>{this.formatMessage({ id: "resetPassword.emailSent" })}</p>
          </div>
        )}
        <ForgotPasswordForm
          onSubmit={this.handleForgotPassword.bind(this)}
          emailAddress={this.state.emailAddress}
        />
      </HomePage>
    );
  }
}

ForgotPasswordPage.contextTypes = {
  intl: intlShape,
};

ForgotPasswordPage.propTypes = {
  auth: PropTypes.shape({
    error: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.shape({
        data: PropTypes.object,
      }),
    ]),
  }),
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

export default connect(mapStateToProps, undefined)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/components/forgot-password/ForgotPasswordPage.js